<template>
  <v-row align="center">
    <v-col md="1">
      <span style="font-size: 18px; font-weight: 400;">Helpers: </span>
    </v-col>

    <v-col md="auto">
      <!-- <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="mr-3"
          >
            Copy albums
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in getObjUniqueValues(data,'album').slice(0,-1)"
            :key="index"
            @click=""
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->

      <v-btn @click="createAdTextCombinations()">
        Create combinations
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { copyTextToClipboard } from '../../../helpers/functions'

  export default {
    name: 'CopyHelpers',
    components: {
    },
    props: {
      data: {
        type: Array
      },
      hotRef: {}
    },
    data () {
      return {
      }
    },
    computed: {
      // adMarkers () {
      //   return toGMapMarkers(this.data)
      // },
      // adCircles () {
      //   return toGMapCircles(this.data)
      // }
    },
    methods: {
      // Copy text
      copyText (text) {
        return copyTextToClipboard(text)
      },
      // Return all available values for a particular object key
      // Sort alphabetically
      getObjUniqueValues (obj_array, key) {
        return obj_array.reduce(function (values, obj) {
          if (!values.includes(obj[key])) {
            values.push(obj[key])
          }
          return values
        }, []).sort()
      },
      // Get data from selected range(s)
      getSelectedCells () {
          let selected = this.hotRef.getSelected()

          let result = []
          for (var i = 0; i < selected.length; i += 1) {
            var item = selected[i]

            result.push(this.hotRef.getData.apply(this.hotRef, item))
          }

          return result
      },
      // Create text combinations - Test
      // multiplyText (starter) {
      //   let newArray = []
      //
      //   for (var row = 0; row < range.length; row++) {
      //     newArray.push(starter[row][0], starter[0][1], starter[0][2])
      //     newArray.push(starter[row][0], starter[0][1], starter[1][2])
      //     newArray.push(starter[row][0], starter[0][1], starter[2][2])
      //
      //     newArray.push(starter[row][0], starter[1][1], starter[0][2])
      //     newArray.push(starter[row][0], starter[1][1], starter[1][2])
      //     newArray.push(starter[row][0], starter[1][1], starter[2][2])
      //
      //     newArray.push(starter[row][0], starter[2][1], starter[0][2])
      //     newArray.push(starter[row][0], starter[2][1], starter[1][2])
      //     newArray.push(starter[row][0], starter[2][1], starter[2][2])
      //   }
      //
      //   this.copyText(newArray)
      //   return newArray
      // },
      // Return first x words
      firstWords (text, num_words) {
        return text.split(' ').slice(0, num_words).join(" ")
      },
      // Create text combinations
      multiplyText (starter) {
        let output = ""

        for (var col1 = 0; col1 < starter.length; col1++) {
          for (var col2 = 0; col2 < starter.length; col2++) {
            for (var col3 = 0; col3 < starter.length; col3++) {
              output += (this.firstWords(starter[col1][0], 2) + '_' + this.firstWords(starter[col2][1], 3) + '_' + this.firstWords(starter[col3][2], 3) + '\t' + starter[col1][0] + '\t' + starter[col2][1] + '\t' + starter[col3][2] + '\n')
            }
          }
        }

        return output
      },
      //
      createAdTextCombinations () {
        const selectedCellData = this.getSelectedCells()
        // Copy output
        this.copyText(this.multiplyText(selectedCellData[0]))
      },
      // Export the data table
      exportDataTable () {
        const exportPlugin = this.hotRef.getPlugin('exportFile')
        exportPlugin.downloadFile('csv', {
            bom: false,
            columnDelimiter: ',',
            columnHeaders: true,
            exportHiddenColumns: true,
            exportHiddenRows: true,
            fileExtension: 'csv',
            filename: 'copy_[YYYY]-[MM]-[DD]',
            mimeType: 'text/csv',
            rowDelimiter: '\r\n',
            rowHeaders: false
          })
      }
    }
  }
</script>
